// Reading a response that might legitimately be empty.
//
// The API returns 204 No Content with an empty body when a collection has no
// rows — 19 controller files do this. `res.ok` is TRUE for 204, so the guard
// that appears all over this codebase:
//
//     res.ok ? res.json() : []
//
// calls res.json() on an empty body and throws:
//
//     SyntaxError: Failed to execute 'json' on 'Response':
//     Unexpected end of JSON input
//
// The catch logs to a console nobody is watching and the screen renders empty
// — so the user sees "no data" when the truth is "the request failed". Found
// 18 Sept 2026 by running Greaterbase against an instance with no data in it,
// but it is not a fresh-instance problem: any filter returning no rows hits
// the same path on trial and production.
//
// This preserves each call site's existing fallback for non-2xx responses. It
// only stops the 204 case throwing. Swallowing a genuine error into an empty
// list is a separate problem, and deliberately not changed here.
export const jsonOr = async (res, fallback = []) => {
  if (res.status === 204 || res.headers.get("content-length") === "0") return fallback;
  if (!res.ok) return fallback;
  return res.json();
};
